import { announcementHubDetailPageInfo } from "./Pages/Hubs/Announcements/DetailPage/pageinfo";
import { calendarEventHubDetailPageInfo } from "./Pages/Hubs/CalendarEvents/DetailPage/pageinfo";
import { newsletterHubDetailPageInfo } from "./Pages/Hubs/Newsletters/DetailPage/pageinfo";
import { postHubDetailPageInfo } from "./Pages/Hubs/Posts/DetailPage/pageinfo";

export const hubDetailPages = {
	Announcement: announcementHubDetailPageInfo,
	CalendarEvent: calendarEventHubDetailPageInfo,
	Newsletter: newsletterHubDetailPageInfo,
	Post: postHubDetailPageInfo,
};
